<template>
  <div class="recycle-bin" v-loading="isDoor && fullScreenLoading">
    <div class="recycle-bin-header" v-if="!isDoor" v-loading.fullscreen="fullScreenLoading">
      <div class="list-search">
        <el-input v-model="searchKey" style="width: 200px"
          placeholder="搜索标题或发起人名称" @keyup.enter="goSearch">
          <template #prefix>
            <el-icon><Search /></el-icon>
          </template>
        </el-input>
        <el-button type="primary" @click="goSearch">搜索</el-button>
      </div>
      <div class="batch">
        <i class="iconfont icon-piliangcaozuo" style="color: rgb(153, 153, 153);"></i>
        <el-dropdown @command="handleCommand" placement="bottom-start" trigger="click">
          <span class="el-dropdown-link">
            <span class="title">批量操作</span>
            <i class="iconfont icon-gengduo" style="font-size: 8px;"></i>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="批量删除">批量删除</el-dropdown-item>
              <el-dropdown-item command="批量恢复">批量恢复</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
      <el-button type="text" style="color: #333333" class="nav-top-filter" @click="isFilter = true">
        <i class="iconfont icon-shaixuanmian" style="color: #19b359; font-size: 14px; margin-right: 3px"></i>
        <span>数据筛选</span>
        <i style="font-size: 8px" class="iconfont icon-gengduo" />
      </el-button>
    </div>
    <div class="recycle-bin-header" v-else>
      <div class="list-search">
        <el-input v-model="searchKey" size="small" style="width: 200px" prefix-icon="el-icon-search"
          placeholder="搜索标题或发起人名称" @keyup.enter="goSearch"></el-input>
        <el-button size="small" type="primary" @click="goSearch">搜索</el-button>
      </div>
      <div class="batch">
        <i class="iconfont icon-piliangcaozuo" style="color: rgb(153, 153, 153);"></i>
        <el-dropdown @command="handleCommand" placement="bottom-start" trigger="click">
          <span class="el-dropdown-link">
            <span class="title">批量操作</span>
            <i class="iconfont icon-gengduo" style="font-size: 8px;"></i>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="批量删除">批量删除</el-dropdown-item>
              <el-dropdown-item command="批量恢复">批量恢复</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
      <el-button type="text" style="color: #333333" class="nav-top-filter" @click="isFilter = true">
        <i class="iconfont icon-shaixuanmian" style="color: #19b359; font-size: 14px; margin-right: 3px"></i>
        <span>数据筛选</span>
        <i style="font-size: 8px" class="iconfont icon-gengduo" />
      </el-button>
    </div>
    <div class="recycle-bin-table">
      <el-table height="100%" @selection-change="handleSelectionChange" border :data="listData.data" style="width: 100%" :stripe="true" :header-cell-style="{ background: '#F5F5F5' }"
        :row-style="{ height: '22px' }" :header-cell-class-name="'header_style'">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column :prop="val.title" v-for="val in tableKey" :min-width="val.width" :key="val.id">
          <template v-slot:header >
            <div class="door-ellipsis" :title="val.name">{{ val.name }}</div>
          </template>
          <template v-slot="scope">
            <div v-if="val.type === 'image' && scope.row[val.title]">
              <el-image @click.stop v-for="(img, imgIndex) in isJSON(scope.row[val.title])" :key="imgIndex"
                style="width: 28px; height: 28px;margin-right: 5px;"
                :src="img.url ? img.url : $imgurl + img.response + '?accesstoken=' + filesConfig()"
                :preview-src-list="[img.url ? img.url : $imgurl + img.response + '?accesstoken=' + filesConfig()]"
                fit="cover" />
            </div>
            <template v-else-if="val.type === 'file'">
              <span class="img-file">
                <i class="iconfont icon-wenjianfujian" v-if="isArrAndNoLen(isJSON(scope.row[val.title]))"></i>
                <span v-for="(item2, idx2) in isJSON(scope.row[val.title])" :key="idx2" class="img-file-style">
                  <el-link @click.stop="goPreview(item2, false)" type="primary" class="img-file-content">
                    {{ strImgAndFileData(item2) }}
                  </el-link>
                  <el-link @click.stop="goPreview(item2, true)" type="primary" class="img-file-content">
                    <i class="iconfont icon-xiazai2x"></i>
                  </el-link>
                  <el-link v-if="getFileFormat(item2.response)" type="primary" class="img-file-content"
                    @click.stop="playFun(item2)">
                    <i class="iconfont icon-bofang"></i>
                  </el-link>
                </span>
              </span>
            </template>
            <div v-else-if="val.type === 'relation-check'">
              <tableRead v-if="getRelCheck(scope.row[val.title])"
                :config="{ list: getRelCheck(scope.row[val.title]).top, title: scope.$index }"
                :formdata="getRelCheck(scope.row[val.title])" />
              <template v-else>{{ strData(scope.row[val.title], val.encrypt) }}</template>
            </div>
            <div v-else-if="val.type === 'number'">
              {{ toDecimal(scope.row[val.title]) }}
            </div>
            <el-popover placement="right" width="400" trigger="hover" v-else-if="
              scope.row[val.title] && scope.row[val.title].list
            ">
              <div>
                <p v-for="item in scope.row[val.title].list" :key="item.id">
                  <span v-for="(item1, index) in item" :key="item1.id">{{ index }}：{{ strData(item1) }}</span>
                </p>
              </div>
              <template #reference>
                <el-button type="text">{{ scope.row[val.title].value }}</el-button>
              </template>
            </el-popover>
            <div v-else-if="val.type === 'query'">
              <template v-if="scope.row[val.title] === ''">
                <div class="btn-query" @click.stop="queryData(scope.row, val)">
                  <i class="iconfont icon-sousuo" />
                  点击查询
                </div>
              </template>
              <template v-else>
                <template v-if="typeof scope.row[val.title] == 'object'">
                  <p v-for="(item, index) in scope.row[val.title]" :key="index">{{ index + 1 }}.{{ item }}</p>
                </template>
                <span v-else>{{ scope.row[val.title] }}</span>
              </template>
            </div>
            <div v-else-if="val.type === 'location'">
              {{ getLocationVal(scope.row[val.title]) }}
            </div>
            <div v-else-if="val.type === 'radio' && val.sels && val.types && val.types === 6">
              <radioXing :sels="val.sels" :value="scope.row[val.title]" />
            </div>
            <div v-else>
              <span v-if="val.title === '状态'" :class="statusFun(scope.row['status'])">{{ scope.row[val.title] }}</span>
              <span v-else-if="val.type === 'richTextWid'">富文本请到详情内查看</span>
              <div v-else :title="strData(scope.row[val.title])" class="ellipsisTwo">
                <template v-if="val.type === 'radio' && fileProperty && fileProperty[val.title] && fileProperty[val.title].types === 4">
                </template>
                <template v-else-if="val.type === 'relation-user'">
                  <span class="relation-user-content" v-for="item in scope.row[val.title]" :key="item.userId"> 
                    <relationUserInfo v-if="val.isMoreInfo" :info="item" :moreInfo="val.moreInfoArr" :isNewInfo="val.isNewData" iconColor='#4E86FF' />
                    <template v-else>{{ item.realname }}</template>
                  </span>
                </template>
                <template v-else>
                  <template v-if="val.type === 'date' && val.match && val.match === 'yyyy-MM-dd ww'">
                    {{ strData(scope.row[val.title], val.encrypt) }} {{ '星期' + getWeek(strData(scope.row[val.title], val.encrypt)) }}
                  </template>
                  <template v-else-if="val.type === 'date'">
                    {{ getTimeLabels(val, scope) }}  
                  </template>
                  <span v-else-if="val.type === 'text' && isLinkObj[val.title]" class="text-link" @click.stop="openLinkText(scope.row[val.title])">
                    {{ strData(scope.row[val.title], val.encrypt) }}
                  </span>
                  <template v-else>
                    {{ val.type === 'radio' && val.sels ? getRadioLabel(strData(scope.row[val.title], val.encrypt), val.sels) : strData(scope.row[val.title], val.encrypt) }}
                  </template>
                </template>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template v-slot="scope">
            <el-button @click.stop="tableRestore(scope.row)" type="text" size="small" style="color: #267CFF;font-size: 14px;">
              <i class="iconfont icon-yichehui todo-icon-color" />
            </el-button>
            <el-button @click.stop="tableDelete(scope.row)" type="text" size="small" style="color: #E5283F;font-size: 14px;">
              <i class="iconfont icon-shanchu5" />
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="recycle-bin-foot">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="listData.pagesize"
        :page-sizes="[25, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="listData.total"
      ></el-pagination>
    </div>
    <batchDialog
      v-model:visible="batch.visible"
      :date="batch"
      :approvalId="approvalId"
      @batch="batchRet"
    />
    <transactionFilter v-model:isFilter="isFilter" v-model:condition="filterQuery" @goFilter="goFilter" :approvalId="approvalId" />
  </div>
</template>

<script>
import { getopenreportformlist, getrecycledatalist, deleterecycledata, recycledata, recycledatabycondition, deleterecycledatabycondition } from '@/port/clientSide/workbench'
import listMixins from './util/listMixins';
import batchDialog from './batchDialog/index.vue'
import transactionFilter from './transationFilter/index.vue'
export default {
  // 组件名称
  name: 'recycleBin',
  // 组件参数 接收来自父组件的数据
  props: {
    appid: {
      type: [String, Number],
      default: ''
    },
    isDoor: {
      type: Boolean,
      default: false
    }
  },
  mixins: [listMixins],
  // 局部注册的组件
  components: {
    batchDialog,
    transactionFilter
  },
  // 组件状态值
  data() {
    return {
      searchCriteria: {},
      fullScreenLoading: false,
      menuListDatas: {},
      otherParams: {
        type: 0,
        curpage: 1,
        pagesize: 25,
        cateId: -1,
        key: '',
      },
      listData: {},
      tableKey: [],
      multipleSelection: [], //table选中的数据
      batch: {},
      searchKey: '',
      filterQuery: [],
      isFilter: false
    }
  },
  // 计算属性
  computed: {
    approvalId() {
      return this.$route.query.approvalId || this.appid
    }
  },
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    init(opt) {
      // 老谭说 暂时不需要看权限
      // const params = {
      //   appid: this.$route.query.approvalId || this.approvalId || this.appid,
      // }
      // 直接去走获取参数的接口
      const params = {
        approvalId: this.approvalId,
        pagesize: 0,
        curpage: 0,
      }
      const spaceid = this.$route.query.spaceid
      const upaceid = this.$route.query.upaceid
      if (spaceid) {
        params.spaceid = spaceid
      } else if (upaceid) {
        params.upaceid = upaceid
      }
      if (this.$route.query.space) {
        delete params.spaceid
        params.spaceid = spaceid || localStorage.getItem('spaceid')
      } else if (this.$route.query.upace) {
        delete params.upaceid
        params.upaceid = upaceid || localStorage.getItem('upaceid')
      }
      getopenreportformlist(params).then((res) => {
        if (res.code === 0) {
          this.menuListDatas = {}
          const data = res.data.find(f => !f.userId)
          this.menuListDatas = data
          let queryData = typeof data.query === 'string' ? JSON.parse(data.query) : data.query
          // 处理 sels 字段，如果是字符串则转为 JSON
          if (Array.isArray(queryData)) {
            queryData = queryData.map(item => {
              if (item.sels && typeof item.sels === 'string') {
                try {
                  item.sels = JSON.parse(item.sels)
                } catch (e) {
                  console.error('解析 sels 失败:', e)
                }
              }
              return item
            })
          }
          this.filterQuery = queryData
          this.getTableKey(data)
          this.getList(opt)
        }
      })
    },
    goFilter(e) {
      if (JSON.stringify(e) !== '{}') {
        this.searchCriteria.query = JSON.stringify(e)
        this.otherParams.query = e
      } else {
        delete this.searchCriteria.query
        delete this.otherParams.query
      }
      //搜索设置值
      this.otherParams.curpage = 1;
      this.otherParams.pagesize = 20;
      this.getList()
    },
    goSearch() {
      const text = this.searchKey
      if (text) {
        this.otherParams.key = text
        this.searchCriteria.key = text
      } else {
        this.otherParams.key = ''
        this.searchCriteria.key = ''
      }
      this.otherParams.curpage = 1;
      this.otherParams.pagesize = 20;
      this.getList()
    },
    batchRet(val) {
      let param = {}
      let api = null
      let msg = ''
      let errmsg = ''
      console.log(val,'valvalval')
      if (this.batch.operate === 'del') {
        api = deleterecycledata
        msg = '删除成功'
        errmsg = '删除失败'
        if (val.radio === 1) {
          // 复选框选中的
          const ids = []
          this.multipleSelection.forEach(item => {
            ids.push(item.id)
          })
          param = {
            ids: ids.join(','),
            approvalId: this.approvalId,
          }
        } else if (val.radio === 3 || val.radio === 2) {
          api = deleterecycledatabycondition
          param = {
            approvalId: this.approvalId,
            reportFormId: this.menuListDatas.reportFormId,
            curpage: 0,
            pagesize: 0,
            cateId: -1,
            key: '',
          }
          if (val.radio === 3) {
            param.query = { 'date_dtime': val.time }
          } else if (val.radio === 2) {
            param = { ...param, ...this.searchCriteria }
          }
        }
      } else if (this.batch.operate === 'recover') {
        // 批量恢复
        msg = '恢复成功'
        errmsg = '恢复失败'
        api = recycledata
        if (val.radio === 1) {
          // 恢复复选框选中的
          const ids = []
          this.multipleSelection.forEach(item => {
            ids.push(item.id)
          })
          param = {
            ids: ids.join(','),
            approvalId: this.approvalId,
          }
        } if (val.radio === 2 || val.radio === 3) {
          api = recycledatabycondition
          param = {
            approvalId: this.approvalId,
            reportFormId: this.menuListDatas.reportFormId,
            curpage: 0,
            pagesize: 0,
            cateId: -1,
            key: '',
          }
          if (val.radio === 3) {
            param.query = { 'date_dtime': val.time }
          } else if (val.radio === 2) {
            param = { ...param, ...this.searchCriteria }
          }
        }
      }
      this.todoFn({ param, msg, api, errmsg })
    },
    handleSizeChange(val) {
      this.otherParams.pagesize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.otherParams.curpage = val
      this.getList()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getTableKey(item) {
      if (item.userReport && item.userReport.content) {
        const content = JSON.parse(item.userReport.content);
        this.tableKey = []
        for (let i = 0; i < content.length; i++) {
          // 容器控件不显示
          if (content[i].checked && content[i].type !== 'container') {
            this.tableKey.push(content[i])
          }
        }
        this.countTable()
      }
    },
    async countTable() {
      await this.$nextTick()
      if (this.tableKey.length > 0 && this.listData && this.listData.data && this.listData.data.length > 0) {
        //先计算表头的字符宽度
        let table = JSON.parse(JSON.stringify(this.tableKey))
        let tableArr = []
        for (let i in table) {
          let width = table[i].title.length * 14
          if (width > 400) {
            table[i].width = 400
          } else if (width < 100) {
            table[i].width = 100
          } else {
            table[i].width = width
          }
          tableArr.push(table[i].title)
        }
        //计算表格里面字符数据
        let list = JSON.parse(JSON.stringify(this.listData.data))
        for (let i in list) {
          for (let a in list[i]) {
            //进行匹配
            let index = tableArr.indexOf(a)
            if (index !== -1) {
              let len = list[i][a].length * 14
              if (len > table[index].width && len > 400) {
                table[index].width = 400
              } else if (len > table[index].width && len < 400) {
                table[index].width = len
              }
            }
          }
        }
        this.tableKey = table
      }
    },
    handleCommand(common) {
      if (common === '批量删除') {
        this.batch = {
          visible: true,
          title: "删除",
          operate: "del",
          repeat: true,
          batchQuery: this.searchCriteria.query || this.searchCriteria.key || "",
          dateLen: this.multipleSelection.length,
        }
      } else if (common === '批量恢复') {
        this.batch = {
          visible: true,
          title: "恢复",
          operate: "recover",
          repeat: false,
          batchQuery: this.searchCriteria.query || this.searchCriteria.key || "",
          dateLen: this.multipleSelection.length,
        }
      }
      
    },
    tableRestore(row) {
      let param = {
        id: row.id,
        approvalId: this.approvalId
      };
      this.$confirm('确定要恢复数据？', {
        confirmButtonClass: 'el-button--yeprimary',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.todoFn({ param, msg: '恢复成功', errmsg: '恢复失败', api: recycledata })
        this.$emit('retRefresh')
      }).catch(() => {
      })
    },
    async todoFn(opt = {}) {
      const { param, msg, errmsg, api } = opt
      const res = await api(param)
      if (res.code === 0) {
        this.$message.success(msg)
        this.getList()
      } else {
        this.$message.error(errmsg)
      }
    },
    tableDelete (row) {
      let param = {
        id: row.id,
        approvalId: this.approvalId
      };
      this.$confirm('确定要删除？', {
        confirmButtonClass: 'el-button--yeprimary',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.todoFn({ param, msg: '删除成功', errmsg: '删除失败', api: deleterecycledata })
      }).catch(() => {
      })
    },
    async getList(opt = {}) {
      const param = {
        ...this.otherParams,
        ...opt,
      }
      this.fullScreenLoading = true
      param.reportFormId = this.menuListDatas.reportFormId
      param.approvalId = this.approvalId
      if (this.isSpace) {
        let spaceId = typeof (this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        param.spaceid = spaceId;
      } else if (this.isUpace) {
        let upaceId = typeof (this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        param.upaceid = upaceId
      }
      const res = await getrecycledatalist(param).catch((err) => {
        console.log(err);
      }).finally(() => {
        this.fullScreenLoading = false
      })
      if (res.code === 0) {
        this.listData = res
      }
    },
  },
}
</script>

<style scoped lang="scss">
.recycle-bin {
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  &-header {
    padding-bottom: 20px;
    padding-top: 10px;
    width: 100%;
    height: 65px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  &-table {
    flex: 1;
  }

  &-foot {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 60px;
    box-sizing: border-box;
  }
}

.list-search {
  display: inline-block;

  ::v-deep .el-input__inner {
    border-right: none;
    border-radius: 4px 0 0 4px;
  }

  ::v-deep .el-button {
    border-radius: 0 2px 2px 0;
    margin-left: -4px;
  }
}

::v-deep .batch {
  margin-left: 20px;
  display: inline-block;

  .title {
    margin: 0 4px;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #333333;
    font-size: 14px;
  }

  .el-icon-arrow-down {
    font-size: 10px;
  }
}

.el-dropdown-menu__item:not(.is-disabled):hover {
  color: #965500;
  background: rgba(255, 253, 246, 1);
}

.nav-top-filter {
  padding-left: 30px;
  color: #333333;

  &:hover {
    color: #4e86ff;
  }
}
</style>
<style lang="scss" scoped>
.text-link {
  text-decoration: underline;
  color: #4e86ff;
  cursor: pointer;
}
::v-deep .radio-switch {
  .el-switch__label {
    white-space: nowrap;
  }
}
.relation-user-content {
  display: inline-block;
  margin-right: 2px;
}
  ::v-deep .stat-block {
    line-height: 23px;
    height: auto;
  }
  ::v-deep .cell .el-button--small {
    padding-top: 0;
    padding-bottom: 0;
  }

  #table-list .el-popover {
  background: #312d28;
  font-size: 14px;
  color: #ffffff;
  border: 1px solid #312d28;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}
#table-list .el-popper[x-placement^="top"] .popper__arrow:after {
  border-top-color: #312d28;
}

.img-file {
  display: flex;
  flex-wrap: wrap;
  .icon-wenjianfujian {
    color: #999999;
    font-size: 14px;
  }
  &-style {
    padding-left: 10px;
    white-space: nowrap;
    .el-link.el-link--primary:hover {
      color: #4e86ff;
    }
    ::v-deep .img-file-content {
      cursor: pointer;
      height: 22px;
      &:first-of-type {
        padding-right: 5px;
      }
      .icon-xiazai2x {
        font-size: 14px;
      }
    }
  }
}


#table-list .cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#table-list .fourText {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}

.tmTibs .el-tabs__nav {
  margin-left: 30px;
  padding: 10px 0;
}
.tmTibs .el-tabs__nav .el-tabs__item {
  font-size: 14px;
}
.el-table .header_style {
  background: #f8f9fb;
}
.row_style {
  color: #000;
  cursor: pointer;
}
.row_style_back {
  background-color: #dce8f3 !important;
}
::v-deep .row_style_back {
  background-color: #f1f8ff !important;
  &.el-table__row--striped > td {
    background-color: #ecf9ef !important;
  }
}
::v-deep .row_style {
  height: 36px;
}

#listMom .el-form-item {
  margin-bottom: 0;
}
</style>

<style lang="scss" scoped>
::v-deep .batch {
  margin-left: 20px;
  display: inline-block;
  .title {
    margin: 0 4px;
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #333333;
    font-size: 14px;
    i {
      color: #999999;
    }
  }

  .el-icon-arrow-down {
    font-size: 10px;
  }
}
.el-dropdown-menu__item:not(.is-disabled):hover {
  color: #965500;
  background: rgba(255, 253, 246, 1);
}
.cor-DC4 {
  color: #14adc4;
}
.cor-6DB {
  color: #1296db;
}
.cor-400 {
  color: #ffb400;
}
.button-list:hover .button-list-text {
  color: #965500;
}
.button-list {
  display: inline-block;
  margin-left: 25px;
  font-size: 16px;
}
.button-list-text {
  font-size: 14px;
}

.el-main {
  background: #fff;
  position: relative;
}

.content {
  position: absolute;
  top: 0px;
  right: 0;
  bottom: 0px;
  overflow: auto;
  left: 225px;
}


.todo-icon-color {
  color: #999 !important;
  &:hover {
    color: #4e86ff !important;
  }
}

.el-button+.el-button{
  margin-left: 0;
}

.el-icon--right {
  padding: 0 10px;
}
.nopadding {
  padding: 0 10px;
}

.dialog-body {
  padding: 16px;
}
.dialog-body .el-checkbox {
  padding-bottom: 12px;
}

::v-deep .el-table {
  .el-table__fixed-body-wrapper {
    top: 34px !important;
  }
}

.dialog-foot {
  padding: 10px 16px;
  border-top: 1px solid #eee;
  display: flex;
  align-items: center;
  &-btn{
    flex: 1;
    text-align: right;
  }
}
.searchRow {
  height: 40px;
  overflow: hidden;
}
.searchBtn p {
  width: 90%;
  margin: 0 auto 10px;
}
.searchBtn p .el-button {
  width: 100%;
}
.searchList {
  width: 100%;
  height: 40px;
  margin: 0;
  padding: 0;
  overflow: hidden;
  .nav-top-filter {
    padding-left: 30px;
    color: #333333;
    &:hover {
      color: #4e86ff;
    }
  }
}
.searchMore {
  text-align: center;
  font-size: 20px;
  color: #4e86ff;
}
.searchMore i {
  cursor: pointer;
}

.el-button {
  font-weight: 400;
}

.btn-query {
  color: #4E86FF;
  cursor: pointer;
}
.query-list {
  height: 100px;
  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
  }
}
</style>
